import React, { Suspense } from 'react';
import { connect } from 'react-redux';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { IntlProvider } from 'react-intl';
import AppLocale from './lang';
import ProtectedRoute from './helpers/authHelper';

export const history = createBrowserHistory();

const Error = React.lazy(() => import('./views/error'));
const Login = React.lazy(() => import('./views/login'));
const Dashboard = React.lazy(() => import('./views/dashboard'));
const Analysis = React.lazy(() => import('./views/analysis'));
const TimeChart = React.lazy(() => import('./views/timechart'));
const Analysis2 = React.lazy(() => import('./views/analysis-2'));
const TimeChart2 = React.lazy(() => import('./views/timechart-2'));
const Positive = React.lazy(() => import('./views/positive'));
const KdeMode = React.lazy(() => import('./views/kde'));
const ColorDesign = React.lazy(() => import('./views/colordesign'));
const Forgot = React.lazy(() => import('./views/forgot'));
// const Reset = React.lazy(() => import('./views/reset'));
const User = React.lazy(() => import('./views/user'));
const UserEdit = React.lazy(() => import('./views/user/edit.jsx'));
const Policy = React.lazy(() => import('./views/policy'));
// const MeetingMasterView = React.lazy(() => import('./views/meeting/master-view'));
// const MeetingUserView = React.lazy(() => import('./views/meeting/user-view'));

function App(props) {

  const { mode } = props;

  const locale = 'ja';
  const currentAppLocale = AppLocale[locale];
  const routes = [
    {id: 'D-0', component: Login, path: '/'},
    {id: 'D-1', component: Forgot, path: '/forgot-password'},
    // {id: 'D-2', component: Reset, path: '/reset-password'},
    {id: 'D-3', component: Policy, path: '/privacypolicy'},
  ];

  const authRoutes = [
    {id: 'D-4', component: Dashboard, path: '/dashboard'},
    {id: 'D-5', component: Analysis, path: '/analysis-data'},
    {id: 'D-6', component: TimeChart, path: '/time-chart'},
    {id: 'D-5-2', component: Analysis2, path: '/analysis-data-2'},
    {id: 'D-6-2', component: TimeChart2, path: '/time-chart-2'},
    {id: 'D-7', component: Positive, path: '/positive-negative'},
    {id: 'D-8', component: KdeMode, path: '/kde-mode'},
    {id: 'D-9', component: ColorDesign, path: '/color-design'},
    {id: 'D-10', component: User, path: '/user'},
    {id: 'M-01', component: UserEdit, path: '/user/edit/:id'},
    // {id: 'M-02', component: MeetingMasterView, path: '/meeting/'},
    // {id: 'M-03', component: MeetingUserView, path: '/meeting/:meetingID'},
  ];

  return (
    <div className={`h-100 ${mode}`}>
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <Suspense fallback={<div className="loading" />}>
          <Router>
            <Switch>
              <Route
                path="/error"
                exact
                render={(props) => <Error {...props} />}
              />
              {routes.map((item, index) => {
                return (
                  <Route
                    key={index.toString()}
                    path={item.path}
                    exact
                    component={item.component}
                  />
                );
              })}
              <ProtectedRoute
                path="/"
                routes={authRoutes}
              />
              <Redirect to="/error" />
            </Switch>
          </Router>
        </Suspense>
      </IntlProvider>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    mode: state.config.mode
  };
};

const mapActionsToProps = {};

export default connect(mapStateToProps, mapActionsToProps)(App);
